import { IconProps } from "../../utils/global-types/global-types";

const StatusChangedIcon = ({ className, ...rest }: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="18"
    height="18"
    fill="none"
    viewBox="0 0 18 18"
    className={className}
    {...rest}
  >
    <g fill="currentColor" clipPath="url(#clip0_4826_74478)">
      <path d="m16.48 8.661-.835-6.178a.437.437 0 0 0-.74-.252l-1.23 1.229A8.61 8.61 0 0 0 2.8 4.5l-.016.016c-.268.268.047.71.394.552 2.49-1.182 5.548-.773 7.628 1.245L9.561 7.558a.436.436 0 0 0 .253.74l6.162.836c.3.047.536-.19.504-.473M14.81 12.932c-2.49 1.182-5.548.773-7.629-1.245l1.245-1.245a.437.437 0 0 0-.252-.74l-6.163-.836c-.283-.032-.535.205-.488.489l.835 6.162a.437.437 0 0 0 .74.252l1.23-1.229a8.61 8.61 0 0 0 10.875-1.04l.016-.016c.268-.284-.047-.725-.41-.552"></path>
    </g>
    <defs>
      <clipPath id="clip0_4826_74478">
        <path fill="#fff" d="M0 0h18v18H0z"></path>
      </clipPath>
    </defs>
  </svg>
);

export default StatusChangedIcon;
